<template>
	<div class="counter-style-two section-padding">
		<div>
			<div class="container">
				<h2 class="titre-section">
					Le bilan
					<span class="span-background-blue">
						en quelques chiffres
					</span>
				</h2>
				<div class="row justify-content-center">
					<div v-for="item in counterData" :key="item.id" class="col-lg-4 col-sm-6" data-aos="fade-up"
						data-aos-duration="1200" :data-aos-delay="item.delay">
						<div class="counter-box-four">
							<img class="img-counter mb-3" :src="item.img" :alt="item.title">
							<p class="title mb-3">{{ item.title }}</p>
							<h2 class="number">
								<span class="timer">
									<span class="chiffre d-flex align-items-center justify-content-center">
										{{ item.value }}
										{{ item.text ? item.text : "" }}
									</span>
								</span>
							</h2>
						</div>
						<!-- /.counter-box-four -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CountUp from "vue-countup-v3";

export default {
	name: "CounterArea",
	components: { CountUp },
	data() {
		return {
			startCounter: false,
			counterData: [
				{
					id: 1,
					img: "/images/pages/bilan-competences/bilan-compteur-icon-1.jpg",
					value: 95,
					title: "Bilans réalisés en 2025",
					text: "",
				},
				{
					id: 2,
					img: "/images/pages/bilan-competences/bilan-compteur-icon-2.jpg",
					value: 96,
					title: "Un taux de satisfaction de ",
					delay: "100",
					text: "%",
				}
			],
		};
	},
	methods: {
		onChange(waypointState) {
			if (waypointState.going === "IN") {
				this.startCounter = true;
			}
		},
	},
};
</script>


<style scoped>
.titre-section {
	color: var(--accent, #25233E);
	text-align: center;
	font-family: Nunito;
	font-size: 3.125rem;
	/*50 px */
	font-style: normal;
	font-weight: 600;
	line-height: 111.5%;
	letter-spacing: -0.825px;
	text-transform: uppercase;
}

.img-counter {
	display: block;
	margin: auto;
}

.chiffre {
	font-family: Nunito;
}

.title {
	font-family: Inter;
	font-size: 1.3125rem;
	font-style: normal;
	font-weight: 600;
}

.section-padding {
	padding: 5rem 0;
}

.counter-box-four {
	background: white;
	padding: 2rem;
	border-radius: 9px;
}

/* Media */
@media only screen and (min-width: 300px) and (max-width: 500px) {
	.img-counter {
		width: 10%;
	}

	.counter-box-four {
		padding: 0.5rem
	}
}

@media only screen and (min-width: 501px) and (max-width: 768px) {
	.img-counter {
		max-width: 20% !important;
	}
}


@media only screen and (min-width: 769px) and (max-width: 991px) {}

@media only screen and (min-width: 992px) and (max-width: 1199px) {}

@media only screen and (min-width: 1200px) {}</style>